import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
import { MSEnum } from '@/commons/enumeration'
import store from '@/stores/store';
class generalSettingAPI extends BaseAPI {
  constructor() {
    super();
  }
    apiName = "TaskGo";
    controllerName = 'GeneralSettings';

    /**
     * Lấy danh sách thiết lập
     * @param {Object} param
     * @returns Danh sách thiết lập
     * @author: LMduc(21/12/2022)
     */
    getPagingGeneralSetting(settingType) {
      let param = {
        columns: 'SettingID, SettingType, SettingValue, SortOrder, IsSystem',
        emptyFilter: '',
        filter: `[{ Field: "SettingType", Opeator: "=", Value: ${settingType} }]`,
        skip: 0,
        sort: 'SortOrder',
        take: -1,
      };
      let request = {
        url: `${this.getAPIUrl()}/list`,
        data: param
      };

      return httpClient.postAsync(request);
    }

    /**
     * Lấy danh sách thiết lập theo loại
     * @param {Object} param
     * @returns Danh sách thiết lập
     * @author: VDGiang 24/8/2023
     */
    getGeneralSettingByType(settingType) {
      let request = {
        url: `${this.getAPIUrl()}/getGeneralSettingByType?type=${settingType}`,
      };

      return httpClient.getAsync(request);
    }

    /**
     * Gọi lên server để lưu thiết lập thời gian quá hạn
     * @param {Object} param
     * @returns Danh sách thiết lập
     * @author: LMduc(21/12/2022)
     */
    saveGeneralSetting(param = {}) {
      let request = {
        url: `${this.getAPIUrl()}/submit`,
        data: param
      };

      return httpClient.postAsync(request);
    }
}

export default new generalSettingAPI();
